import ACTIONS from 'application/constants'

export const openAktenPopupSidebar = () => ({
    type: ACTIONS.SIDEBAR_OPEN_AKTEN
})

export const closeAktenPopupSidebar = () => ({
    type: ACTIONS.SIDEBAR_CLOSE_AKTEN
})